"use client";
import styles from "./EventDetails.module.css";
import TicketsPurchase from "../../components/Tickets/TicketsPurchase/TicketsPurchase";
import {
  EventMap,
  EventImage,
  EventTitle,
  EventInfo,
  EventLineup,
  EventDescription,
  EventCategories,
} from "../../components/Event";
import { useEffect, useState, useRef, use } from "react";
import { formatDateTimeWithTimezone } from "../../utils/dateformat";
import EventAccessCode from "@components/Event/EventAccessCode/EventAccessCode";
import EventGuestList from "@components/Event/EventGuestList/EventGuestList";
import Navbar from "@layout/Navbar/Navbar";
import SearchBar from "@components/Searchbar/SearchBar";
import { useRouter, useSearchParams } from "next/navigation";
import Footer from "@layout/Footer/Footer";
import { useUser } from "@hooks/Auth/useUser";
import {
  getAttendeesProfiles,
  getEventsLocation,
  submitInviteCode,
} from "@services/eventAPI";
import GetTheAppDialog from "@components/GetTheAppDialog/GetTheAppDialog";
import { isValidPhoneNumber } from "react-phone-number-input";
import "./snowFall.scss";

import EventTable from "@components/Event/EventTable/EventTable";
// import ReactGA from "react-ga4";
import VerifyPhoneDialog from "@components/VerifyPhone/verifyDialog";
import EventSeatingMap from "@components/Event/EventSeatingMap/EventSeatingMap";
import Link from "next/link";
import { sendGTMEvent } from "@next/third-parties/google";
import { getSurveyData } from "@services/typeform";
import Cookies from "js-cookie";
import SurveyForm from "@components/typeform/typeform";
import AttendeesRow from "@components/Attendees/AttendeesRow/AttendeesRow";
import GuestListRes from "@components/Attendees/GuestList";
import CookieConsent from "@components/CookieConsent/CookieConsent";
import { tr } from "date-fns/locale";
import DataPolicy from "@components/DataPolicy/DataPolicy";
import { set } from "date-fns";

const EventDetails = ({ event = {}, allEvents = [] }) => {
  let { user, refresh } = useUser();
  // const { location, loading, askForLocation } = useLocation();
  // console.log(location);
    const [countries, setCountries] = useState([]);
  const [userCountry, setUserCountry] = useState("United Arab Emirates");
  const [locationPermissionChecked, setLocationPermissionChecked] =
    useState(false);
  const [askLocation, setAskLocation] = useState(false);
  const enableInviteHolderCode = event.enableInviteHolderCode;
  console.log(enableInviteHolderCode);
  useEffect(() => {
    const fetchLocationData = async () => {
      const co = await getEventsLocation();

      const savedCountry = Cookies.get("userCountry");

      if (savedCountry) {
        setUserCountry(savedCountry);
        setLocationPermissionChecked(true);
      } else {
        setAskLocation(true); // Show the dialog to ask manually
      }
    };
    fetchLocationData();
    sendGTMEvent({
      event: "page_viewed",
      event_id: eventID, // eventID
      organizer_id: orgID,
    }); // organizerID
  }, []);
    // 1. Load list of available countries once
    useEffect(() => {
      let cancelled = false;
      getEventsLocation()
        .then((data) => {
          if (!cancelled) setCountries(data);
        })
        .catch((err) => {
          if (!cancelled) console.error("Country load error", err);
        });
      return () => {
        cancelled = true;
      };
    }, []);
  const [joinButtons, setJoinButtons] = useState({
    existingTable: enableInviteHolderCode,
    newOrder: false,
  });
  const [inviteCode, setInviteCode] = useState("");
  const [showDefaultTickets, setShowDefaultTickets] = useState(
    !enableInviteHolderCode
  );
  const handleExistingOrder = (e) => {
    e.preventDefault();
    setJoinButtons({ existingTable: true, newOrder: false });
  };
  const handleNewOrder = (e) => {
    e.preventDefault();
    setReplaceByNewTickets(false);
    setInviteCode("");
    localStorage.removeItem("inviteCode");
    setJoinButtons({ existingTable: false, newOrder: true });
  };
  const [loadingSubmitCode, setLoadingSubmitCode] = useState(false);
  const [errorSubmitCode, setErrorSubmitCode] = useState("");
  const [inviteTicket, setInviteTicket] = useState([]);
  const [replaceByNewTickets, setReplaceByNewTickets] = useState(false);
  const handleConfirmExistingOrder = async (e) => {
    e.preventDefault();
    if (inviteCode.length === 0) {
      setErrorSubmitCode("Empty!");
      return;
    }
    setLoadingSubmitCode(true);
    setErrorSubmitCode("");
    try {
      const res = await submitInviteCode(eventID, inviteCode);

      const data = res.data.data;
      console.log(data);
      let filteredGroups;
      groups.map(
        (t) => {
          console.log(t.tickets);
          filteredGroups = t.tickets.filter((tt) => {
            return tt.ticketID === data.allowedTicketID;
          });
        }
        // (t) => t.tickets.ticketID === data.allowedTicketID
      );
      const filteredTickets = tickets.filter((t) => {
        return t.ticketID === data.allowedTicketID;
      });
      console.log(filteredTickets, filteredGroups);
      const combinedArray = [
        ...(filteredTickets ?? []),
        ...(filteredGroups ?? []),
      ];
      console.log(combinedArray);

      setInviteTicket(combinedArray);
      localStorage.setItem("inviteCode", inviteCode);
      setReplaceByNewTickets(true);
    } catch (error) {
      console.log(error);
      setErrorSubmitCode(error.response.data.message);
    } finally {
      setLoadingSubmitCode(false);
    }
  };
  useEffect(() => {
    if (enableInviteHolderCode && joinButtons.newOrder)
      setShowDefaultTickets(true);
    if (enableInviteHolderCode && joinButtons.existingTable)
      setShowDefaultTickets(false);
  }, [joinButtons]);
  const {
    eventID,
    startDate,
    endDate,
    timezoneMap = [],
    imageUrl,
    name,
    description,
    orgSnippet,
    orgID,
    locationData,
    tickets = [],
    lineup = [],
    isLocationHidden,
    venueName,
    musicTypes = [],
    gateway = "",
    guestlists,
    tables,
    groups = [],
    artistsData,
    seatingTickets,
    seatingData,
    dynamicUrl,
  } = event || {};
  function useWindowSize() {
    // Initialize state with undefined width/height so server and client renders match
    // Learn more here: https://joshwcomeau.com/react/the-perils-of-rehydration/
    const [windowSize, setWindowSize] = useState({
      width: undefined,
      height: undefined,
    });

    useEffect(() => {
      // if(location === null)askForLocation()
      // sendGTMEvent({ event: "event_page_view" });
      // if (orgID === "15M0Nzs6N5F62jFv4H2a") {
      //   sendGTMEvent({ event: "ViewContentJA", organization: "John Achkar" });
      // }

      // only execute all the code below in client side
      // Handler to call on window resize
      function handleResize() {
        // Set window width/height to state
        setWindowSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      }

      // Add event listener
      window.addEventListener("resize", handleResize);

      // Call handler right away so state gets updated with initial window size
      handleResize();

      // Remove event listener on cleanup
      return () => window.removeEventListener("resize", handleResize);
    }, []); // Empty array ensures that effect is only run on mount
    return windowSize;
  }
  const size = useWindowSize();
  console.log(size);
  console.log(event);
  // ReactGA.send({ hitType: "pageView", page: `/${eventID}`, title: `${name}` });
  useEffect(() => {
    // Check if the user agent indicates a webview
    const isWebview = /webview/i.test(navigator.userAgent);

    // If it's a webview, redirect to an external browser
    if (isWebview) {
      window.location.href = "https://tickit.co";
    }

    localStorage.removeItem("nationality");
    localStorage.removeItem("guestPhoneNumber");
  }, []);
  const [successDob, setSuccessDob] = useState(false);
  const [detectDate, setDetectDate] = useState(false);
  const [detectPhoneNumber, setDetectPhoneNumber] = useState(false);
  const [detectGender, setDetectGender] = useState(false);
  const [detectCountry, setDetectCountry] = useState(false);
  // const trackButtonClick = () => {
  //   Adjust.trackEvent({
  //     eventToken: "5gg1m7",
  //   });
  // };

  const isValidDate = (dateString) => {
    if (!dateString || dateString === "") {
      return;
    }
    const regEx = /^\d{4}-\d{2}-\d{2}$/;
    // console.log(dateString);
    if (!dateString.match(regEx)) return false; // Invalid format
    const date = new Date(dateString);
    const isValid = date && !Number.isNaN(date.getTime());
    return isValid;
  };
  const handleSuccessDob = () => {
    setSuccessDob(true);
    // console.log("refreshed");
    refresh();
  };
  const checkAge = (dateString) => {
    if (!isValidDate(dateString)) {
      return false; // Invalid date format
    }
    const today = new Date();
    const birthDate = new Date(dateString);
    let age = today.getFullYear() - birthDate.getFullYear();
    let monthDiff = today.getMonth() - birthDate.getMonth();
    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }
    return age >= 0;
  };
  function isObjectEmpty(obj) {
    return obj && Object.keys(obj).length === 0 && obj.constructor === Object;
  }
  function isObjectNull(obj) {
    return obj === null;
  }
  useEffect(() => {
    const waitForFbq = setInterval(() => {
      if (window.fbq) {
        console.log(window.fbq);
        if (orgID === "Ea0wlLRXJ5SvZ1DMwlZx") {
          window.fbq("track", "PageView");
        }
        clearInterval(waitForFbq);
      }
    }, 100);

    // Cleanup in case the component unmounts
    return () => clearInterval(waitForFbq);
  }, []);

  const DateChecker = () => {
    if (isObjectEmpty(user) || isObjectNull(user)) {
      return;
    }

    // console.log(user.country);
    // if (user.country === "") {
    //   // console.log(country);
    //   setDetectCountry(true);
    // }
    !isValidPhoneNumber(user.phoneNumber) && setDetectPhoneNumber(true);
    isValidPhoneNumber(user.phoneNumber) && setDetectPhoneNumber(false);

    user.gender === "" && setDetectGender(true);
    user.gender !== "" && setDetectGender(false);

    user.country === "" && setDetectCountry(true);
    user.country !== "" && setDetectCountry(false);
    const isValidAndOlderThan18 = checkAge(user.dob);

    setDetectDate(isValidAndOlderThan18);
    console.log(!detectDate, detectPhoneNumber, detectGender, detectCountry);
  };
  useEffect(() => {
    if (!isObjectEmpty(user) || !isObjectNull(user)) {
      DateChecker();
      console.log(detectDate);
    }
  }, [user]);
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true); // Set isClient to true once the component is mounted
  }, []);
  useEffect(() => {
    if (!isObjectEmpty(user) || !isObjectNull(user)) {
      DateChecker();
      // console.log(detectDate);
    }
  }, [successDob]);
  useEffect(() => {
    DateChecker();
    // console.log(detectDate);
    // console.log(!isObjectEmpty(user), !isObjectNull(user));
  }, [user]);
  // const test = async () => {
  //   const response = await getEvents("eventID", eventID);
  //   return response;
  // };
  const searchParams = useSearchParams();
  const utm_source = searchParams.get("utm_source");
  useEffect(() => {
    if (!utm_source && !eventID) return;
  
    // only run in the browser
    if (typeof window === "undefined") return;
  
    let existingData = [];
    try {
      const raw = sessionStorage.getItem("trackingData");
      existingData = raw ? JSON.parse(raw) : [];
    } catch (error) {
      console.error("Error parsing trackingData from sessionStorage:", error);
    }
  
    if (!Array.isArray(existingData)) existingData = [];
  
    const isDuplicate = existingData.some(
      (entry) =>
        entry.utm_source === utm_source && entry.eventID === eventID
    );
  
    if (!isDuplicate) {
      existingData.push({
        utm_source: utm_source || "",
        eventID: eventID || "",
      });
      sessionStorage.setItem(
        "trackingData",
        JSON.stringify(existingData)
      );
    }
  }, [utm_source, eventID]);
  
  // test()
  //   .then((response) => // console.log(response))
  //   .catch((e) => console.error(e));

  const formattedDateTimeStart = startDate
    ? formatDateTimeWithTimezone(startDate, timezoneMap)
    : undefined;

  const formattedDateTimeEnd = endDate
    ? formatDateTimeWithTimezone(endDate, timezoneMap)
    : undefined;

  const offersSchema = tickets.flatMap((ticket) =>
    ticket?.sales.map((sale) => {
      let validFrom = "Invalid date";
      let validThrough = "Invalid date";
      if (sale.from) {
        try {
          validFrom = formatDateTimeWithTimezone(sale.from, timezoneMap);
        } catch (err) {
          console.error("Invalid sale.from:", sale.from);
        }
      } else {
        console.error("Invalid or missing sale.from:", sale.from);
      }

      if (sale.till) {
        try {
          validThrough = formatDateTimeWithTimezone(sale.till, timezoneMap);
        } catch (err) {
          console.error("Invalid sale.till:", sale.till);
        }
      } else {
        console.error("Invalid or missing sale.till:", sale.till);
      }

      return {
        "@type": "Offer",
        name: `${ticket.name} - ${sale.waveName}`, // Include the wave name in the offer name
        price: sale.price,
        priceCurrency: ticket.currency,
        availability: ticket.isAvailable
          ? "http://schema.org/InStock"
          : "http://schema.org/OutOfStock",
        validFrom,
        validThrough,
      };
    })
  );

  const performerSchema = lineup.map((performer) => ({
    "@type": "PerformingGroup",
    name: performer.name,
    genre: performer.genre,
  }));

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Event",
    "@id": event?.eventID,
    name: event?.name,
    image: event?.image,
    description: event?.description,
    startDate: formattedDateTimeStart,
    endDate: formattedDateTimeEnd,
    performer: performerSchema,
    offers: offersSchema,
    organizer: {
      "@type": orgSnippet?.type,
      name: orgSnippet?.orgName,
      image: orgSnippet?.orgImage,
    },
    location: {
      "@type": "Place",
      name: venueName,
      address: {
        "@type": "PostalAddress",
        streetAddress: "123 Example Street",
        addressLocality: locationData?.city,
        postalCode: "12345",
        addressRegion: locationData?.place,
        addressCountry: locationData?.addressCountry,
      },
    },
  };

  const [passwordDialogOpen, setPasswordDialogOpen] = useState(
    !!event.accessCode
  );
  const [accessGranted, setAccessGranted] = useState(!event.accessCode);
  const [isSearchBarVisible, setIsSearchBarVisible] = useState(false);
  const [openMissingData, setOpenMissingData] = useState(false);
  const [passwordError, setPasswordError] = useState("");
  const handlePasswordSubmit = (password) => {
    if (password === event.accessCode) {
      setAccessGranted(true);
      setPasswordDialogOpen(false);
      setPasswordError(""); // reset the error message
    } else {
      setPasswordError("Wrong password!"); // This is just for the example, you can handle it in a better way.
    }
  };
  const router = useRouter();
  const handleDialogClose = () => {
    router.push("/");
  };

  useEffect(() => {
    // // console.log(
    //   user && user.updatedFields.dob,
    //   user && user.updatedFields.dob === true
    // );
    const updatedFields = user.updatedFields;
    const dobUpdated = updatedFields && updatedFields.dob;

    // Alternatively, you can use optional chaining to avoid the error
    const dobUpdated1 = user.updatedFields?.dob;
    if (user && dobUpdated === false) {
      setOpenMissingData(true);
    }
  }, [user, openMissingData]);

  const NavRef = useRef(null);

  const handleControlNav = () => {
    if (NavRef.current) {
      NavRef.current.toggleState();
    }
  };

  const [openSeatingMap, setOpenSeatingMap] = useState(false);

  const handleOpenCloseSeating = () => {
    if (user && user?.id)
      setOpenSeatingMap((prev) => {
        return !prev;
      });
    else {
      handleControlNav();
    }
  };
  const seatingDataMap = {
    image: seatingData?.imageUrl,
    seatingMapID: seatingData?.seatingMapID,
    seatingTickets: seatingTickets,
    utm_source: utm_source,
    eventID: eventID,
  };

  // Attendees

  const [attendees, setAttendees] = useState([]);
  const [loadingAttendees, setLoadingAttendees] = useState(false);
  const [attendeesProfiles, setAttendeesProfiles] = useState();
  const [hideAttendees, setHideAttendees] = useState(false);
  const [loadingAttendeesProfiles, setLoadingAttendeesProfiles] = useState(false);
  const [finish, setFinish] = useState(false);
  const getAttendees = async () => {
    setLoadingAttendeesProfiles(true);
    console.log("in test");
    setFinish(false);
    try {
      const res = await getAttendeesProfiles(eventID, user?.id, user?.idToken);
      console.log("in test 1: ", res);
      setAttendeesProfiles(res.data);
      if(res.status === 200) {
        // if(!res.data.data.showCount && !res.data.data.showProfiles)

        // if(res.data.data.profiles.length === 0) {
        //   setHideAttendees(true);
        // }
      }
      else {
        setHideAttendees(true)
      }
    } catch (error) {
      console.log(error);
      setHideAttendees(true);
      // if (error.response?.status === 401) {
      //   // remove whatever cookie holds your auth token
      //   Cookies.remove("token");
      //   // if you have other cookies (idToken, user, etc.), remove them too
      //   Cookies.remove("idToken");
      //   Cookies.remove("user");

      //   // trigger your useUser() hook to re-fetch (and clear) the user
      //   refresh();
      // }
    }
    setFinish(true);
    setLoadingAttendeesProfiles(false);
  }
  useEffect(() => {
    console.log("jhgfdtxcfgyvhbg", user?.id, user);

    // if (user && user?.id) {
      console.log("jhgfdhij");

      getAttendees();
    // }
  }, [user]);
  useEffect(() => {
    console.log("jhgfdhij", event.whoCanSeeAttendees);
  if(event.whoCanSeeAttendees === "everyone") 
    getAttendees();
  }, []);
  // survey
  const [showSurvey, setShowSurvey] = useState(false);
  const [surveyData, setSurveyData] = useState(null);
  const [surveyLoading, setSurveyLoading] = useState(false);
  const userToken = user.idToken;
  console.log(user);

  // Utility: has it been ≥13 days since last check?
  const shouldCheckSurvey = () => {
    const last = Cookies.get("lastSurveyCheck");
    if (!last) return true;
    const elapsed = Date.now() - Number(last);
    return elapsed > 1000 * 60 * 60 * 24 * 13;
  };

  // Fetch once every 14 days
  useEffect(() => {
    console.log("user token", userToken);
    console.log("shouldCheckSurvey", shouldCheckSurvey());

    if (!userToken || !shouldCheckSurvey()) return;

    setSurveyLoading(true);
    getSurveyData(userToken, false)
      .then((res) => {
        if (res.status === "success" && res.data.showSurvey) {
          setSurveyData(res.data);
          setShowSurvey(true);
        }
      })
      .catch(console.error)
      .finally(() => {
        // record our “check” timestamp
        Cookies.set("lastSurveyCheck", String(Date.now()), { expires: 365 });
        setSurveyLoading(false);
      });
  }, [user]);

  // When survey is submitted
  const handleForSubmit = () => {
    setShowSurvey(false);
  };

  // If they click “Skip”
  const handleSkip = async () => {
    if (!surveyData) return;
    try {
      await skipSurvey(userToken, surveyData.surveyID);
    } catch (e) {
      console.error("skipSurvey failed", e);
    }
    setShowSurvey(false);
  };

  // …inside your render() …
  if (showSurvey) {
    return (
      <div className={styles.surveyOverlay}>
        <SurveyForm
          surveyId={surveyData.surveyID}
          userId={user.id}
          handleForSubmit={handleForSubmit}
          handleSkip={handleSkip}
        />
      </div>
    );
  }
    const profiles = attendeesProfiles?.data?.profiles || [];
  const totalCount = attendeesProfiles?.data?.attendeesCount || 0;
  const shownCount = profiles.length;
  const subtractCount = shownCount <= 5 ? shownCount : 5;
  const countLabel = `${totalCount - subtractCount}+ Going`;
  // End
    // Handle user consent setting
    const handleConsent = (country) => {
      Cookies.set("userCountry", country, { expires: 365 });
      setUserCountry(country);
    };
    const [openPolicy, setOpenPolicy] = useState(false);
    const [policyCase, setPolicyCase] = useState("");
    
    const handleOpenPolicy = (policyCase) => {
      setPolicyCase(policyCase);
      setOpenPolicy(true);
    };
      
    const handleClosePolicy = () => {
      if (policyCase === "not loggedIn") {
        if (utm_source)
          router.push(`/login/${eventID}?utm_source=${utm_source}`);
        else router.push(`/login/${eventID}`);
      }
      if (policyCase === "loggedIn") {
        if (utm_source)
          router.push(`/payment/${eventID}?utm_source=${utm_source}`);
        else router.push(`/payment/${eventID}`);
      }
      if (policyCase === "seatingMap") {
        if (utm_source)
          router.push(
            `/payment/${eventID}?utm_source=${utm_source}&is_seat=true`
          );
        else router.push(`/payment/${eventID}?is_seat=true`);
      }
      if (policyCase === "guest") {
        if (utm_source)
          router.push(`/guest/${eventID}?utm_source=${utm_source}`);
        else router.push(`/guest/${eventID}`);
      }
      setOpenPolicy(false);
    };
    
    return (
      <>
        <div className={styles.all}>
          <div
            style={{ backgroundImage: `url(${imageUrl})` }}
            className={styles.bg}
          ></div>

          {accessGranted && allEvents && (
            <>
              {false && dynamicUrl && dynamicUrl?.shortLink && (
                <div className={styles.appReturn}>
                  for better experience{" "}
                  <Link
                    href={`https://${
                      dynamicUrl?.shortLink ?? "link.tickit.co/2d3"
                    }`}
                  >
                    Open App
                  </Link>
                </div>
              )}
              <Navbar
                onSearchIconClick={() => setIsSearchBarVisible(true)}
                allEvents={allEvents}
                utm_source={utm_source}
                eventID={eventID}
                ref={NavRef}
              />
              <SearchBar
                events={allEvents}
                open={isSearchBarVisible}
                onClose={() => setIsSearchBarVisible(false)}
              />
              {Cookies.get("userCountry") && event.continueAsGuest && (
                  <GetTheAppDialog
                    message={
                      "We just launched our new app you can download it on the link below !"
                    }
                  />
                )}
            </>
          )}

          {!accessGranted && (
            <div>
              <EventAccessCode
                onClose={handleDialogClose}
                isOpen={true}
                onPasswordSubmit={handlePasswordSubmit}
                passwordError={passwordError}
              />
            </div>
          )}
          {false && accessGranted && <VerifyPhoneDialog phoneNumber={true} />}
          {
            accessGranted && (
              <main className={styles.wrapper}>
                <script
                  type="application/ld+json"
                  dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
                />

                <div className={styles.container}>
                  <header>
                    {imageUrl && name && (
                      <EventImage imageUrl={imageUrl} name={name} />
                    )}
                    {orgSnippet && name && (
                      <EventTitle
                        name={name}
                        orgSnippet={orgSnippet}
                        startDate={startDate}
                        endDate={endDate}
                        timezoneMap={timezoneMap}
                        orgID={orgID}
                      />
                    )}
                    {
                      <AttendeesRow
                        attendees={attendeesProfiles?.data?.profiles}
                        countLabel={countLabel}
                        showCount={attendeesProfiles?.data?.showCount}
                        showProfiles={attendeesProfiles?.data?.showProfiles}
                        hide={false}
                        finish={finish}
                      />
                    }
                    {musicTypes && (
                      <EventCategories musicTypes={musicTypes} details={true} />
                    )}
                    {locationData && (
                      <EventInfo
                        startDate={startDate}
                        endDate={endDate}
                        timezoneMap={timezoneMap}
                        locationData={locationData}
                        venueName={venueName}
                        isLocationHidden={isLocationHidden}
                      />
                    )}
                  </header>
                  {isClient &&
                    tables?.isPublic &&
                    typeof window !== "undefined" &&
                    window.innerWidth <= 750 &&
                    eventID === "JZUeXtfk5wIpNDGyINxE" && (
                      <section className={styles.border}>
                        <EventTable link={tables.appTablesUrl} />
                      </section>
                    )}
                  {enableInviteHolderCode && (
                    <div className={styles.invitesDialog1}>
                      <div className={styles.invitesDialog}>
                        <div className={styles.info}>
                          {joinButtons.newOrder ? (
                            <p>New Table</p>
                          ) : (
                            <p>Existing Table</p>
                          )}
                          {joinButtons.newOrder ? (
                            <p>
                              Choose this if you’re starting a new table. After
                              booking, you’ll receive an invite code, which you
                              can share with friends to allow them to join your
                              table.
                            </p>
                          ) : (
                            <p>
                              Select this if your friends have already booked a
                              table and you want to join them. Enter the invite
                              code shared by your friends and proceed to
                              purchase your ticket.
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  {showDefaultTickets && enableInviteHolderCode && (
                    <div className={styles.invitesDialog}>
                      <div
                        style={{
                          display: "flex",
                          gap: "20px",
                          marginTop: "10px",
                        }}
                      >
                        <button
                          onClick={handleExistingOrder}
                          style={
                            joinButtons.existingTable
                              ? { backgroundColor: "rgba(255,255,255,0.5)" }
                              : {}
                          }
                        >
                          Existing Table
                        </button>
                        <button
                          onClick={handleNewOrder}
                          style={
                            joinButtons.newOrder
                              ? { backgroundColor: "rgba(255,255,255,0.5)" }
                              : {}
                          }
                        >
                          New Order
                        </button>
                      </div>
                    </div>
                  )}

                  {!showDefaultTickets && (
                    <div className={styles.invitesDialog1}>
                      <div className={styles.invitesDialog}>
                        {/* <div className={styles.info}>
                        {joinButtons.newOrder ? (
                          <p>Join an existing reservation?</p>
                        ) : (
                          <p>Join an existing reservation?</p>
                        )}
                        {joinButtons.newOrder ? (
                          <p>
                            Select this if your friends have already booked a
                            table and you want to join them. Enter the invite
                            code shared by your friends and proceed to purchase
                            your ticket.
                          </p>
                        ) : (
                          <p>
                            Select this if your friends have already booked a
                            table and you want to join them. Enter the invite
                            code shared by your friends and proceed to purchase
                            your ticket.
                          </p>
                        )}
                      </div> */}
                        <div
                          style={{
                            display: "flex",
                            gap: "20px",
                            alignItems: "center",
                          }}
                        >
                          <button
                            onClick={handleExistingOrder}
                            style={
                              joinButtons.existingTable
                                ? { backgroundColor: "rgba(255,255,255,0.5)" }
                                : {}
                            }
                          >
                            Existing Table
                          </button>
                          <button
                            onClick={handleNewOrder}
                            style={
                              joinButtons.newOrder
                                ? { backgroundColor: "rgba(255,255,255,0.5)" }
                                : {}
                            }
                          >
                            New Order
                          </button>
                        </div>
                      </div>
                      {!replaceByNewTickets ? (
                        <div className={styles.invitesDialog2}>
                          <div>
                            <input
                              type="text"
                              placeholder="# Invite Code"
                              onChange={(e) => setInviteCode(e.target.value)}
                              value={inviteCode}
                            />
                            {errorSubmitCode.length > 0 && (
                              <p style={{ color: "red", fontSize: "12px" }}>
                                {errorSubmitCode}
                              </p>
                            )}
                          </div>
                          <div>
                            <button
                              onClick={handleConfirmExistingOrder}
                              disabled={loadingSubmitCode}
                              style={
                                loadingSubmitCode
                                  ? { cursor: "not-allowed", opacity: "0.5" }
                                  : {}
                              }
                            >
                              Confirm
                            </button>
                          </div>
                        </div>
                      ) : (
                        <section id="ticket-purchase">
                          <TicketsPurchase
                            tickets={inviteTicket}
                            eventID={eventID}
                            groups={[]}
                            gateway={gateway}
                            event={event}
                            enableInviteHolderCode={
                              event.enableInviteHolderCode
                            }
                            utm_source={utm_source}
                            handleOpenCloseSeating={handleOpenCloseSeating}
                            hideGroup={true}
                          />
                        </section>
                      )}
                    </div>
                  )}
                  {(tickets?.length > 0 || groups?.length > 0) &&
                    showDefaultTickets && (
                      <section id="ticket-purchase">
                        <h2 className={styles.visually_hidden}>
                          Ticket Purchase
                        </h2>
                        <TicketsPurchase
                          tickets={tickets}
                          eventID={eventID}
                          groups={groups}
                          gateway={gateway}
                          event={event}
                          enableInviteHolderCode={event.enableInviteHolderCode}
                          utm_source={utm_source}
                          handleOpenCloseSeating={handleOpenCloseSeating}
                          handleOpenPolicy={handleOpenPolicy}
                        />
                      </section>
                    )}
                  {seatingData &&
                    seatingData?.seatingMapID &&
                    showDefaultTickets && (
                      <section className={styles.border}>
                        <EventSeatingMap
                          seatingDataMap={seatingDataMap}
                          user={user}
                          tickets={tickets}
                          groups={groups}
                          utm_source={utm_source}
                          sizeScreen={size}
                          handleOpenCloseSeating={handleOpenCloseSeating}
                          setOpenSeatingMap={setOpenSeatingMap}
                          openSeatingMap={openSeatingMap}
                          enableInviteHolderCode={enableInviteHolderCode}
                          controlNav={handleControlNav}
                          event={event}
                          handleOpenPolicy={handleOpenPolicy}
                        />
                      </section>
                    )}
                  {guestlists && guestlists.length > 0 && (
                    <section className={styles.border}>
                      <EventGuestList
                        guestlists={guestlists}
                        event={event}
                        controlNav={handleControlNav}
                      />
                    </section>
                  )}

                  {isClient &&
                    tables?.isPublic &&
                    typeof window !== "undefined" &&
                    window.innerWidth <= 750 &&
                    eventID !== "JZUeXtfk5wIpNDGyINxE" && (
                      <section className={styles.border}>
                        <EventTable link={tables.appTablesUrl} />
                      </section>
                    )}
                  {eventID === "5Pyd1IWa3AHUUYhHReD1" && (
                    <section className={styles.border}>
                      <div className={styles.description_wrap}>
                        <h2>Floorplan</h2>
                        <img
                          src="https://firebasestorage.googleapis.com/v0/b/ticket-development-6f3af.appspot.com/o/temp%2FWhatsApp%20Image%202024-11-22%20at%2018.18.00.jpeg?alt=media&token=059b536d-56b4-4c1b-a808-768138b8932c"
                          alt=""
                        />
                      </div>
                    </section>
                  )}
                  {eventID === "JVUo2n3Wrkj99cG1lFL2" && (
                    <section className={styles.border}>
                      <div className={styles.description_wrap}>
                        <h2>Floorplan</h2>
                        <img
                          src="https://firebasestorage.googleapis.com/v0/b/ticket-development-6f3af.appspot.com/o/temp%2FIMG_3929.jpeg?alt=media&token=9360f0ec-a565-4953-a057-059343b3bd4f"
                          alt=""
                        />
                      </div>
                    </section>
                  )}
                  {eventID === "DP7lqTIa4op4CRdpg3Ja" && (
                    <section className={styles.border}>
                      <div className={styles.description_wrap}>
                        <h2>Floorplan</h2>
                        <img
                          src="https://firebasestorage.googleapis.com/v0/b/ticket-development-6f3af.appspot.com/o/98aefa6b-5ead-4a1d-b41c-65218a167caf.JPG?alt=media&token=740cc84a-a015-4935-95c9-5326c80dc8a9"
                          alt=""
                        />
                      </div>
                    </section>
                  )}
                  {eventID === "EWXlBCukopqPtCxjT7Iq" && (
                    <section className={styles.border}>
                      <div className={styles.description_wrap}>
                        <h2>Fair Map</h2>
                        <img
                          src="https://firebasestorage.googleapis.com/v0/b/ticket-development-6f3af.appspot.com/o/temp%2Fimage.png?alt=media&token=106d12ba-50ae-4cbb-a6dd-68bc61df108c"
                          alt=""
                        />
                      </div>
                    </section>
                  )}

                  {description && (
                    <section className={styles.border}>
                      <EventDescription description={description} />
                    </section>
                  )}
                  {attendeesProfiles && (
                    <GuestListRes
                      guests={attendeesProfiles?.data?.profiles}
                      isLoading={attendeesProfiles ? false : true}
                      hide={false}
                      finish={finish}
                    />
                  )}
                  {((lineup && lineup.length > 0) ||
                    (artistsData && artistsData.length > 0)) && (
                    <section className={styles.border}>
                      <EventLineup lineup={lineup} artistsData={artistsData} />
                    </section>
                  )}

                  {locationData && (
                    <section className={styles.border}>
                      <EventMap
                        location={locationData}
                        isLocationHidden={isLocationHidden}
                        eventID={eventID}
                      />
                    </section>
                  )}
                  <Footer isDetails={true} />
                </div>
                {/* <Footer /> */}
              </main>
            )
            // ))
          }
        </div>
        {!Cookies.get("userCountry") && (
          <CookieConsent onConsent={handleConsent} countries={countries} />
        )}
        {openPolicy && (
          <DataPolicy
            onClose={handleClosePolicy}
            type={event?.doorPolicy?.type ?? ""}
            description={event?.doorPolicy?.description ?? ""}
            onCancel={() => setOpenPolicy(false)}
          />
        )}
      </>
    );
};

export default EventDetails;
